var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobRoleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3683 7H16.0289V5C16.0289 3.89543 15.1335 3 14.0289 3V3H10.0289V3C8.92435 3 8.02892 3.89543 8.02892 5V7H4.63135C3.53135 7 2.63135 7.9 2.63135 9V19C2.63135 20.1 3.53135 21 4.63135 21H19.3683C20.4683 21 21.3683 20.1 21.3683 19V9C21.3683 7.9 20.4683 7 19.3683 7ZM10.0289 5.2C10.0289 5.08954 10.1185 5 10.2289 5H13.8289C13.9394 5 14.0289 5.08954 14.0289 5.2V6.8C14.0289 6.91046 13.9394 7 13.8289 7H10.2289C10.1185 7 10.0289 6.91046 10.0289 6.8V5.2ZM19.3683 18C19.3683 18.5523 18.9206 19 18.3683 19H5.63135C5.07906 19 4.63135 18.5523 4.63135 18V10C4.63135 9.44772 5.07906 9 5.63135 9H18.3683C18.9206 9 19.3683 9.44772 19.3683 10V18Z",
    fill: "#6860EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 13.0524C12.6098 13.0524 13.1042 12.558 13.1042 11.9481C13.1042 11.3382 12.6098 10.8438 11.9998 10.8438C11.3899 10.8438 10.8955 11.3382 10.8955 11.9481C10.8955 12.558 11.3899 13.0524 11.9998 13.0524Z",
    fill: "#6860EE",
    stroke: "#6860EE",
    strokeWidth: 1.0348,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78613 15.9434C8.78613 14.8388 9.68156 13.9434 10.7861 13.9434H13.2139C14.3184 13.9434 15.2139 14.8388 15.2139 15.9434V16.8105C15.2139 17.3628 14.7662 17.8105 14.2139 17.8105H9.78613C9.23385 17.8105 8.78613 17.3628 8.78613 16.8105V15.9434Z",
    fill: "#6860EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobRoleIcon);
export default __webpack_public_path__ + "static/media/job-role-icon.aa386e0ceccdb5d419a9b50995f21dd2.svg";
export { ForwardRef as ReactComponent };